import { Button, Modal } from 'flowbite-react';
import React, { useState } from 'react'
import { HiDownload, HiUpload } from 'react-icons/hi';
import { MdDownload, MdUploadFile } from 'react-icons/md';
import { useCSVDownloader } from 'react-papaparse';
import { useCSVReader } from 'react-papaparse';
import ShowDriveRoomModal from './ShowDriveRoom';
import { addDriveRoomsInput } from 'types';



const AddDriveRooms: React.FC = () => {
  const csvTemplate = [
    {
      city: "bangalore",
      buildingName: "Masai Building",
      floorName: "G",
      roomName: "Ninja"
    },
  ];
  const [keys, setKeys] = useState<string[]>([]);
  const [rows, setRows] = useState<addDriveRoomsInput[]>([]);
  const [isModalOpen, setIsModalOpenModal] = useState<boolean>(false);
  const { CSVDownloader } = useCSVDownloader();
  const { CSVReader } = useCSVReader();

  const handleCSVUpload = (results: { data: Array<Array<string>> }): void => {
    let [keys, ...valueArray] = results.data;
    setKeys(keys);

    let data = valueArray
      .filter(row => row.length > 0)
      .map((row: string[]) => {
        return keys.reduce((acc: Record<string, string>, key: string, index: number) => {
          acc[key] = row[index];
          return acc;
        }, {});
      });
    setRows(data as addDriveRoomsInput[]);
    setIsModalOpenModal(true);
  };

  const fileName = 'Download Sample CSV';


  return (
    <>

      <div className="flex items-center justify-center w-screen h-screen relative">
        <div className="absolute top-1/4 transform -translate-y-1/4 flex flex-col items-center justify-center w-full p-6 mx-auto bg-white shadow-lg rounded-lg max-w-lg md:max-w-md sm:max-w-sm">
          <h2 className="mb-4 text-2xl font-semibold text-gray-800">Add New Room</h2>

          <div className='flex gap-6'>
            <div className="relative group">
              <CSVDownloader filename={fileName || 'CSVTemplate'} bom={true} data={csvTemplate}>
                <Button color="purplePlaced">
                  <HiDownload size="20px" />
                </Button>
              </CSVDownloader>

              <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-max px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                Download Sample CSV
              </span>
            </div>

            <div className="relative group">
              <CSVReader onUploadAccepted={handleCSVUpload}>
                {({ getRootProps }: any) => (
                  <Button color="purplePlaced" type="submit" onClick={() => setRows([])} {...getRootProps()}>
                    <HiUpload size="20px" />
                  </Button>
                )}
              </CSVReader>

              <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-max px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                Upload CSV
              </span>
            </div>
          </div>
        </div>
      </div>





      {isModalOpen && (
        <ShowDriveRoomModal
          isOpen={isModalOpen}
          data={rows}
          header='Drive Rooms'
          onClose={() => setIsModalOpenModal(false)}
        />
      )}

    </>
  )
}

export default AddDriveRooms